export const IMAGES = {
  logo: "/images/logo.png",
  hero: "/images/carport.jpeg",
  stairs: "/images/stairs-railing.jpeg",
  carportDrive: "/images/tribune.jpeg",
  pergola: "/images/tribune-gate.jpeg",
  table: "/images/table.jpeg",
  tableGlass: "/images/table-glass.jpeg",
  tablesOffice: "/images/tables-office.jpeg",
  tableDining: "/images/table-dining.jpeg",
  tableChairs: "/images/table-chairs.jpeg",
  stadium: "/images/stadium-2.jpeg",
  stadiumAlt: "/images/stadium-1.jpeg",
  stadium3: "/images/stadium-3.jpeg",
  stadiumTribune: "/images/stadium-tribune.jpeg",
  carwash: "/images/whatsapp-new.jpeg",
  carwashExterior: "/images/carwash-exterior.jpeg",
  gate1: "/images/gate-1.jpeg",
  gate2: "/images/gate-2.jpeg",
  gate3: "/images/gate-3.jpeg",
  parmak1: "/images/parmak-1.jpeg",
  parmak2: "/images/parmak-2.jpeg",
  tableWhite: "/images/new-a.jpeg",
  tableShelf: "/images/new-b.jpeg",
  tableOval: "/images/new-c.jpeg",
  loungeSet: "/images/new-d.jpeg",
  hallIndustrial: "/images/hall-industrial.jpeg",
  hallInterior: "/images/hall-interior.jpeg",
  roofStructure: "/images/roof-structure.jpeg",
  stairsCloseup: "/images/stairs-closeup.webp",
};

export const CONTACT = {
  phoneDisplay: "00 389 070 546 703",
  phoneHref: "tel:+38970546703",
  whatsapp: "https://wa.me/38970546703",
  email: "albesiaxh@hotmail.com",
  emailHref: "mailto:albesiaxh@hotmail.com",
  address: "Rr. 101 bb, Çellopek – Tetovë, Maqedonia e Veriut",
  mapEmbed: "https://maps.google.com/maps?q=Albesi-AXH%20Rr.%20101%20bb%20Chelopek%20North%20Macedonia&z=15&output=embed",
  mapLink: "https://www.google.com/maps/search/?api=1&query=Albesi-AXH%20Rr.%20101%20bb%20Chelopek%20North%20Macedonia",
  instagram: "https://www.instagram.com/albesi_axh_metal/",
  facebook: "https://www.facebook.com/100028611437522/",
  hours: [
    { day: "E Hënë – E Shtunë", time: "09:00 – 18:00" },
    { day: "E Djelë", time: "Mbyllur" },
  ],
};

export const NAV_LINKS = [
  { label: "Ballina", href: "#ballina" },
  { label: "Rreth nesh", href: "#rreth-nesh" },
  { label: "Shërbimet", href: "#sherbimet" },
  { label: "Punimet", href: "#punimet" },
  { label: "Kontakt", href: "#kontakt" },
];

export const TRUST_ITEMS = [
  { value: "30+", label: "Vite përvojë" },
  { value: "01", label: "Cilësi dhe precizion" },
  { value: "100%", label: "Garanci për punën" },
  { value: "EU", label: "Transport në Evropë" },
];

export const SERVICES = [
  { title: "Dyer oborri dhe rrethoja metalike", desc: "Dyer hyrjeje, porte oborri dhe gardhe të realizuara me precizion, siguri dhe dizajn modern – nga modelet klasike deri te prerjet dekorative me lazer." },
  { title: "Konstruksione të mëdha metalike", desc: "Struktura industriale dhe komerciale në përmasa të mëdha – stadiume, autolarje, hala dhe objekte profesionale, të ndërtuara për të zgjatur." },
  { title: "Mbulesa dhe konstruksione të personalizuara", desc: "Mbulesa për oborre, garazhe dhe tarraca, si dhe çdo konstruksion metalik sipas dimensioneve dhe kërkesave të sakta të klientit." },
  { title: "Shkallë dhe punime dekorative prej metali", desc: "Shkallë, parmakë dhe detaje dekorative me prerje precize dhe përfundim elegant, që i japin çdo hapësire karakter." },
  { title: "Tavolina dhe mobilje me strukturë metalike", desc: "Tavolina kuzhine, ngrënieje, pune dhe dhoma ndejëje – mobilje të forta me dizajn modern, të ndërtuara për përdorim të përditshëm." },
];

export const GALLERY_ITEMS = [
  { src: IMAGES.gate3, category: "dyer", title: "Portë me prerje dekorative me lazer", tall: true },
  { src: IMAGES.stairs, category: "shkalle", title: "Parmak shkallësh me prerje gjeometrike", tall: true },
  { src: IMAGES.stadiumTribune, category: "konstruksione", title: "Tribunë stadiumi me çati metalike", tall: true },
  { src: IMAGES.gate2, category: "dyer", title: "Portë rrëshqitëse moderne për oborr", tall: true },
  { src: IMAGES.parmak1, category: "shkalle", title: "Parmak me shqiponjë — prerje me lazer", tall: true },
  { src: IMAGES.stadium, category: "rrethoja", title: "Rrethim stadiumi në përmasa të mëdha", tall: true },
  { src: IMAGES.gate1, category: "dyer", title: "Portë me profile vertikale", tall: true },
  { src: IMAGES.carwashExterior, category: "konstruksione", title: "Autolarje self-service — konstruksion metalik", tall: false },
  { src: IMAGES.parmak2, category: "shkalle", title: "Shkallë druri me parmak metalik", tall: true },
  { src: IMAGES.tableDining, category: "tavolina", title: "Tavolinë ngrënieje me këmbë metalike", tall: true },
  { src: IMAGES.carportDrive, category: "konstruksione", title: "Mbulesë metalike për oborr", tall: false },
  { src: IMAGES.tableGlass, category: "tavolina", title: "Tavolinë konference", tall: true },
  { src: IMAGES.pergola, category: "konstruksione", title: "Pergolë metalike për tarracë", tall: true },
  { src: IMAGES.carwash, category: "konstruksione", title: "Konstruksion metalik për autolarje", tall: false },
  { src: IMAGES.tablesOffice, category: "tavolina", title: "Tavolina pune për zyrë", tall: false },
  { src: IMAGES.stadiumAlt, category: "rrethoja", title: "Rrethim metalik i fushës sportive", tall: true },
  { src: IMAGES.stadium3, category: "rrethoja", title: "Rrethim me rrjetë metalike për objekt sportiv", tall: true },
  { src: IMAGES.tableChairs, category: "tavolina", title: "Tavolinë kuzhine me strukturë metalike", tall: true },
  { src: IMAGES.table, category: "tavolina", title: "Tavolinë pune me kornizë metalike", tall: false },
  { src: IMAGES.hero, category: "konstruksione", title: "Konstruksion metalik për garazh", tall: false },
  { src: IMAGES.hallIndustrial, category: "konstruksione", title: "Hallë industriale me konstruksion metalik", tall: true },
  { src: IMAGES.hallInterior, category: "konstruksione", title: "Konstruksion çatie për objekt industrial", tall: true },
  { src: IMAGES.roofStructure, category: "konstruksione", title: "Strukturë metalike çatie", tall: true },
  { src: IMAGES.stairsCloseup, category: "shkalle", title: "Detaj parmaku me prerje gjeometrike", tall: true },
  { src: IMAGES.tableOval, category: "tavolina", title: "Tavolinë mbledhjesh ovale me xham", tall: true },
  { src: IMAGES.loungeSet, category: "tjera", title: "Garniturë e jashtme me kornizë metalike", tall: true },
  { src: IMAGES.tableShelf, category: "tavolina", title: "Tavolina dhe rafte për dhomë ndejëje", tall: true },
  { src: IMAGES.tableWhite, category: "tavolina", title: "Tavolinë kuzhine me këmbë metalike", tall: true },
];

export const GALLERY_FILTERS = [
  { key: "te-gjitha", label: "Të gjitha" },
  { key: "dyer", label: "Dyer" },
  { key: "rrethoja", label: "Rrethoja" },
  { key: "konstruksione", label: "Konstruksione" },
  { key: "shkalle", label: "Shkallë" },
  { key: "tavolina", label: "Tavolina" },
  { key: "tjera", label: "Të tjera" },
];

export const REVIEWS = [
  { name: "Amin Abduli", when: "5 muaj më parë" },
  { name: "Artan Abdulai", when: "5 vite më parë" },
  { name: "Elmedin Abduli", when: "7 vite më parë" },
  { name: "Resonant energy", when: "7 vite më parë" },
  { name: "N. Ademi", when: "7 vite më parë" },
];
